
// import axios from "axios";

// const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "https://snap4me.up.railway.app";

// export const getJobMap = async () => {
//   try {
//     const storedUser =
//       localStorage.getItem("user") ||
//       localStorage.getItem("localUser");

//     const user = storedUser
//       ? JSON.parse(storedUser)
//       : null;

//     const userId = user?.id;

//     if (!userId) {
//       throw new Error("Logged-in user ID not found.");
//     }

//     const url = `${API_BASE_URL}/api/job-map`;

//     console.log("[JOB MAP] Calling API...");
//     console.log("[JOB MAP] User ID:", userId);
//     console.log("[JOB MAP] URL:", url);

//     const response = await axios.get(url, {
//       headers: {
//         "X-User-ID": String(userId),
//       },
//     });

//     console.log("[JOB MAP] API RESPONSE:", response.data);

//     return response.data;

//   } catch (error) {
//     console.error(
//       "[JOB MAP SERVICE ERROR]",
//       error.response?.status,
//       error.response?.data || error.message
//     );

//     throw error;
//   }
// };

// export const getJobInspectionPhotos = async (jobId) => {
//   try {
//     const storedUser =
//       localStorage.getItem("user") ||
//       localStorage.getItem("localUser");

//     const user = storedUser
//       ? JSON.parse(storedUser)
//       : null;

//     const userId = user?.id;

//     if (!userId) {
//       throw new Error("Logged-in user ID not found.");
//     }

//     const url = `${API_BASE_URL}/api/job-map/${jobId}/images`;

//     console.log("[JOB MAP PHOTOS] Calling API...");
//     console.log("[JOB MAP PHOTOS] Job ID:", jobId);
//     console.log("[JOB MAP PHOTOS] URL:", url);

//     const response = await axios.get(url, {
//       headers: {
//         "X-User-ID": String(userId),
//       },
//     });

//     console.log(
//       "[JOB MAP PHOTOS] API RESPONSE:",
//       response.data
//     );

//     return response.data;
//   } catch (error) {
//     console.error(
//       "[JOB MAP PHOTOS ERROR]",
//       error.response?.status,
//       error.response?.data || error.message
//     );

//     throw error;
//   }
// };

import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://snap4me.up.railway.app";

export const getJobMap = async () => {
  try {
    const storedUser =
      localStorage.getItem("user") ||
      localStorage.getItem("localUser");

    const user = storedUser
      ? JSON.parse(storedUser)
      : null;

    const userId = user?.id;

    if (!userId) {
      throw new Error("Logged-in user ID not found.");
    }

    const url = `${API_BASE_URL}/api/job-map`;

    console.log("[JOB MAP] Calling API...");
    console.log("[JOB MAP] User ID:", userId);
    console.log("[JOB MAP] URL:", url);

    const response = await axios.get(url, {
      headers: {
        "X-User-ID": String(userId),
      },
    });

    console.log("[JOB MAP] API RESPONSE:", response.data);

    return response.data;

  } catch (error) {
    console.error(
      "[JOB MAP SERVICE ERROR]",
      error.response?.status,
      error.response?.data || error.message
    );

    throw error;
  }
};

export const getJobInspectionPhotos = async (jobId) => {
  try {
    const storedUser =
      localStorage.getItem("user") ||
      localStorage.getItem("localUser");

    const user = storedUser
      ? JSON.parse(storedUser)
      : null;

    const userId = user?.id;

    if (!userId) {
      throw new Error("Logged-in user ID not found.");
    }

    // Get the JWT used for TechZeus API authentication
    const jwt = localStorage.getItem("jwt");

    if (!jwt) {
      throw new Error("Authentication token not found.");
    }

    const url =
      `${API_BASE_URL}/api/inspection-photos/${jobId}`;

    console.log("[JOB MAP PHOTOS] Calling API...");
    console.log("[JOB MAP PHOTOS] Job ID:", jobId);
    console.log("[JOB MAP PHOTOS] URL:", url);

    const response = await axios.get(url, {
      headers: {
        "X-User-ID": String(userId),
        "Authorization": `Bearer ${jwt}`,
      },
    });

    console.log(
      "[JOB MAP PHOTOS] API RESPONSE:",
      response.data
    );

    return response.data;

  } catch (error) {
    console.error(
      "[JOB MAP PHOTOS ERROR]",
      error.response?.status,
      error.response?.data || error.message
    );

    throw error;
  }
};